import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()

export const getJob = ( abortToken) => {
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.get("/Job", config);
  }


export const createJob =(data ,abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.post(`/Job`, data, config)
}

export const updateJob =(id, data,abortToken )=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.put(`/Job/${id}`, data, config)
}

export const deleteJob =(id,abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.delete(`/Job/${id}`, config)
}